<template>
  <v-layout row justify-end>
    <v-btn color="success" dark @click.stop="initScan" small round>
      <v-icon left>mdi-barcode-scan</v-icon>
      {{ title }}
    </v-btn>

    <v-dialog v-model="dialog" scrollable persistent max-width="500">
      <v-card>
        <!-- <v-text-field v-model="testBarcode" label="Test barcode" />
        <v-btn @click="onBarcodeScanned(testBarcode)">Insertar codigo</v-btn> -->
        <v-card-title v-show="providerId === 8 || providerId === 1">
          <v-select
            v-model="selected"
            :items="listProvider"
            item-text="name"
            item-value="id"
            label="Select"
            persistent-hint
            return-object
            single-line
          />
        </v-card-title>
        <v-card-title>
          <v-text-field
            v-model="documentCountByProvider"
            :disabled="true"
            type="number"
            value="0"
            :label="$t('scan-component.scanned-document-count')"
            prepend-icon="mdi-barcode-scan"
            class="px-2"
          />
        </v-card-title>

        <v-card-text style="height: 300px">
          <div v-for="barcode in barcodesToShow" :key="barcode">
            <p>{{ barcode }}</p>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="text-xs-center">
          <v-layout row>
            <v-flex justify-center>
              <v-btn
                color="success"
                dark
                flat
                @click.stop="emitBarcodes"
                round
                >{{ $t("scan-component.finish-scan-button-label") }}</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import i18n from "../../i18n/index";

export default {
  props: {
    title: {
      type: String,
      default: i18n.t("scan-component.start-scan-button-label"),
    },
    listProvider: {
      type: Array,
      default: () => [],
    },
    barcodesByProvider: {
      type: Object,
      default: () => {},
    },
    providerId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialog: false,
      barcodes: [],
      selected: "",
      documentCount: 0,
      newBarcode: "",
      barcodesToShow: [],
      documentCountByProvider: 0
    };
  },
  watch: {
    selected: { 
        handler(selectedValue) {
          this.barcodesToShow = this.barcodesByProvider[this.selected.id];
          this.documentCountByProvider = this.barcodesByProvider[this.selected.id].length;
        },
        deep: true
    }
  },
  // computed: {
  //   barcodesToShow() {
  //     return this.barcodesByProvider[this.selected.id];
  //   },
  //   documentCountByProvider() {
  //     return this.barcodesByProvider[this.selected.id].length
  //   }
  // },
  mounted() {
    this.selected = this.listProvider[0]
    window.addEventListener("keydown", (e) => {
      if (e.keyCode === 187) {
        e.preventDefault();
        return;
      }
    });
  },
  destroyed() {
    this.$barcodeScanner.destroy();
  },
  methods: {
    initScan() {
      this.dialog = true;
      this.$barcodeScanner.init(this.onBarcodeScanned);
      this.$forceUpdate()
    },
    onBarcodeScanned(barcode) {
      if (barcode === "Enter") {
        return;
      }

      if (!this.barcodes.includes(barcode)) {
        this.barcodes.push(barcode)
        this.barcodesByProvider[this.selected.id].unshift(barcode);
        this.barcodesToShow = this.barcodesByProvider[this.selected.id];
        this.documentCountByProvider = this.barcodesByProvider[this.selected.id].length;
        this.documentCount++;
        this.$forceUpdate();
      } else {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("scan-component.barcode-scanned-already"),
        });
      }
    },
    emitBarcodes() {
      this.$barcodeScanner.destroy();
      this.$emit("providerBarcodes", this.barcodesByProvider);
      this.dialog = false;
    },
  }
};
</script>